<template>
  <div class="d-flex d-inline-flex">
      <div>
          <v-menu
              ref="datePickerMenu"
              v-model="datePickerMenu"
              :close-on-content-click="false"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="250px"
              :nudge-top="450"
              :nudge-left="0"
          >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dateFormatted"
                    :label="label"
                    :placeholder="placeholderDate"
                    mask="##/##/####"
                    :rules="[rules.dateMatch]"
                    validate-on-input
                    return-masked-value
                    append-icon="event"
                    v-bind="attrs"
                    :name="nameDate"
                    v-validate="isRequired ? 'required' : ''"
                    :error-messages="errors.collect(nameDate)"
                    @blur="date = parseDate(dateFormatted)"
                    @click:append="datePickerMenu = true"
                ></v-text-field>
              </template>
              <v-date-picker v-model="date"
                           title
                           :min="minDate"
                           :locale="currentLanguage"
                           @input="datePickerMenu = false">

            </v-date-picker>
          </v-menu>
      </div>
      <div>
          <v-menu
            v-model="timePickerMenu"
            ref="timePickerMenu"
            :close-on-content-click="false"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="250px"
            :nudge-top="440"
            :nudge-left="0"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="timeFormatted"
                    :placeholder="placeholderHour"
                    mask="##:##"
                    :rules="[rules.hourMatch]"
                    validate-on-input
                    return-masked-value
                    append-icon="access_time"
                    v-bind="attrs"
                    :name="nameHour"
                    v-validate="isRequired ? 'required' : ''"
                    :error-messages="errors.collect(nameHour)"
                    @blur="time = formatTime(timeFormatted)"
                    @click:append="timePickerMenu = true"
                ></v-text-field>
            </template>
            <v-time-picker v-model="time"
                           title
                           @click:minute="$refs.timePickerMenu.save(time)"
                           format="24hr">

            </v-time-picker>
        </v-menu>
      </div>
  </div>
</template>

<script>
export default {
    name: 'CdDateTimePicker',
    $_veeValidate: {
        validator: 'new'
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: 'Data/Hora'
        },
        placeholderDate: {
            type: String,
            default: 'DD/MM/AAAA'
        },
        placeholderHour: {
            type: String,
            default: 'HH:SS'
        },
        minDate: {
            type: String,
            default: new Date(Date.now()).toISOString().substring(0,10)
        },
        nameDate: {
            type: String,
            default: 'Data'
        },
        nameHour: {
            type: String,
            default: 'Hora'
        },
        isRequired: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            date: null,
            time: null  ,
            timeFormatted: null,
            dateFormatted: null,
            datePickerMenu: false,
            timePickerMenu: false,
            rules:{
                hourMatch: value => this.validatorTime(value),
                dateMatch: value => this.validatorDate(value)
            }
        }
    },
    computed: {
        currentLanguage() {
            return this.$vuetify.lang.current
        },
    },
    mounted() {
        this.dateTimeFormat()
    },
    methods: {
        validatorDate(date){
            if(!date || date === '') return true
            if(date.length <= 9) return true
            if(!this.isTodayOrAfter(date)) return 'A data deve ser igual a atual ou uma data futura'
            return date.match(/((^([0-2]?\d\/(0[1-9]|1[0-2])))|(^30\/(01|0[3-9]|1[0-2]))|(^31\/(01|0[3578]|10|12)))\/\d{4}$/gm) || 'A data está inválida'
        },
        validatorTime(time){
            if(!time || time === '') return true
            if(time.length <= 4) return true
            return time.match(/^([0-1]?\d|2[0-3]):[0-5]\d$/gm) || 'A hora está inválida.'
        },
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate (date) {
            if (!date) return null

            const [day, month, year] = date.split('/')
            if(!day || !month || !year) return
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        dateTimeFormat(){
            if(!this.value) return
            const [date, time] = this.value.split('T')
            if(!date || !time) return
            this.timeFormatted = time.substring(0, 5)
            this.dateFormatted = this.formatDate(date)
            this.date = date
            this.time = this.timeFormatted
        },
        formatTime(value) {
            if(!value) return null

            return `${value}:00`
        },
        updateDateTime(){
            if(this.time && this.date)
                this.$emit('input', this.formatDateTimeToSend())
            else
                this.$emit('input', null)
        },
        formatDateTimeToSend(){
            const dateTimeSemOffset = `${this.date}T${this.time}`
            const offset = this.getDateTimeOffset(dateTimeSemOffset)
            const dateTimeComOffset = dateTimeSemOffset+offset

            return this.moment(dateTimeComOffset)
                .utcOffset(this.getDateTimeOffset(dateTimeComOffset))
                .format('YYYY-MM-DDTHH:mm:ss.SSSZZ')

        },
        getDateTimeOffset(dateTime){
            return this.moment(dateTime)
                .tz(this.$store.state.loki.timezone)
                .format('Z')
        },
        isTodayOrAfter(date){
            const inputDate = date.split('/')
            const currentDate = new Date()
            const toInteger = (value) => Number.parseInt(value)

            if(toInteger(inputDate[2]) < currentDate.getFullYear()) return false
            else if(toInteger(inputDate[2]) === currentDate.getFullYear()){
                if(toInteger(inputDate[1]) < currentDate.getMonth()) return false
                else if(toInteger(inputDate[1]) === currentDate.getMonth()){
                    if(toInteger(inputDate[0]) < currentDate.getUTCDate()) return false
                }
            }
            return true
        }
    },
    watch: {
        date () {
            this.dateFormatted = this.formatDate(this.date)
            this.updateDateTime()
        },
        time(value){
            this.timeFormatted = value
            this.updateDateTime()
        },
        'value'(){
            this.dateTimeFormat()
            this.updateDateTime()
        }
    }
}
</script>